<template>
    <div id="app">
        <router-view style="flex: 1;overflow: hidden;display: flex;" />
    </div>
</template>

<script>
export default ({
    created() {
        //强制网址后面带index.html,避免CDN对根目录(http://domain.com/)刷新太慢
        if ((window.location.pathname || '').endsWith('/')) window.location.pathname += 'index.html';
        if (window.location.query('isdebug')) window.isdebug = window.location.query('isdebug');
    },
});
</script>

<style lang="scss">
html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    background: whitesmoke;
    color: #2c3e50;

    text-align: left;
    height: 100%;
    width: 100%;
    display: flex;

    overflow: hidden;
}

ul {
    margin: 0;
    padding: 0;

    li {
        list-style: none;
    }
}

.longtext {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>


<style lang="scss">
.childs-margin-right10 > * {
    margin-right: 10px !important;
}
.childs-margin-bottom10 > * {
    margin-bottom: 10px !important;
}

.fullscreen {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.row {
    display: flex;
    flex-direction: row;
}
.row-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.col {
    display: flex;
    flex-direction: column;
}

.pm-10 {
    padding: 10px 0 0 10px !important;

    > * {
        margin: 0 10px 10px 0 !important;
    }
}
.delete {
    color: #aaa !important;
    text-decoration: line-through !important;   //删除线

    > * {
        color: #aaa !important;
    }
}
.error {
    color: red !important;
    > * {
        color: red !important;
    }
}
.refund {
    color: blue !important;
    > * {
        color: blue !important;
    }
}

.flex-warp {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0 0 10px !important;

    > * {
        margin: 0 10px 10px 0 !important;
    }
}
</style>